// react compiler 编译之后会使用 field.value 作为缓存条件，导致数据变化时 UI 没更新
'use no memo'
import { ArrayField } from '@formily/core'
import { useField } from '@formily/react'
import { isNil } from 'lodash'

import { toArray } from '@eastcoal/common/utils/array'
import { uuid } from '@eastcoal/common/utils/uuid'

const TABLE_ROW_KEY = Symbol('TABLE_ROW_KEY')

export const useEditableTableDataSource = () => {
  const field = useField<ArrayField>()

  const dataSource = toArray(field.value).map(item => {
    if (isNil(item[TABLE_ROW_KEY])) {
      item[TABLE_ROW_KEY] = uuid()
    }
    return item
  })

  return {
    dataSource,
    rowKey: TABLE_ROW_KEY
  }
}
